/* eslint-disable @typescript-eslint/no-explicit-any */

import { AxiosResponse } from 'axios';
import { UseFormGetValues, UseFormSetError } from 'react-hook-form';
import { UseMutateAsyncFunction } from 'react-query';
import { DefaultValues } from './defaultValues';

interface HandleNextProps {
  page: number;
  max: number;
  getValues: UseFormGetValues<DefaultValues>;
  setError: UseFormSetError<DefaultValues>;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  onBoardUser: UseMutateAsyncFunction<AxiosResponse<any, any>, unknown, DefaultValues, unknown>;
  isLoading: boolean;
}

export const handleNext = async ({
  page,
  max,
  getValues,
  setPage,
  onBoardUser,
}: HandleNextProps): Promise<void> => {
  if (page === max) {
    try {
      const values = getValues();
      await onBoardUser(values);
    } catch (error) {
      console.error('Error during submission:', error);
    }
  } else {
    setPage(page + 1);
  }
};

/* eslint-disable @typescript-eslint/no-explicit-any */
